<template>
  <div>
    <!-- 顶部 -->
    <div class="head">
      <h1 @click="navigateHome">我的美食记后台管理</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SidebarSearch',
  methods: {
    navigateHome() {
      if (this.$route.path !== '/') {
        this.$router.replace('/'); // 替代 push
      }
    },
  },
};
</script>

<style scoped>
.head {
   position: fixed;
    left: 0;
    right: 0;
    top: 0;
   display: flex;
  align-items: center;
   justify-content: center;
  height: 64px;
  padding: 0 32px;
  background: linear-gradient(135deg, #854685 0%, #c06c84 50%, #f3a683 100%);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.head h1 {
  color: #ffffff;
  font-family: "宋体";
  display: block;
  text-align: center;
  font-size:23px; /* 字体大小使用vw */
}
</style>
